module.exports = __webpack_public_path__ + "static/media/hab5-2.c15a8ced.jpg";